import type { ICard } from "../../cardsSlice";

export const major2Card: ICard = {
    id: "major_2",
    arcana: "major",
    number: 2,
    suit: "major",
    court: "major",
    name: "Верховная Жрица",
    nameEn: "The High Priestess",
    keywords: ["Интуиция", "Тайна", "Пассивное знание"],
    symbolism: [
      "Женщина между черным и белым столпами",
      "Свиток 'Тора'",
      "Полумесяц под ногами",
      "Завеса с гранатами"
    ],
    symbolismInterpretation:
      "Символ внутреннего знания, скрытых истин, пассивного восприятия",
    archetype: "Хранительница секретов, архетип внутренней мудрости и великой матери",
    psychology: "Интуитивное восприятие, пассивное постижение, доверие внутреннему голосу",
    upright: {
      personality: "Проницательность, чувствительность, внутренняя тишина",
      relationships: "Скрытые мотивы, ожидание, молчаливое знание",
      work: "Наблюдение, анализ, интуитивное принятие решений",
      spirituality: "Контакт с бессознательным и интуитивное знание",
      examples: ["Выжидание", "Слушать себя", "Понимание без действий"]
    },
    reversed: {
      meaning: "Самообман, закрытость, подавление интуиции",
      nuances: "Потеря связи с внутренним знанием"
    },
    associations: ["Ночь", "Луна", "Молчание", "Скрытое"],
    combinations: [
      "С Магом — баланс активного и пассивного начала",
      "С Жрицами — усиление интуиции"
    ],
    readingTips: ["Не торопить события", "Доверять ощущениям и наблюдениям"],
    selfQuestions: [
      "Что скрыто от глаз?",
      "Что я чувствую под поверхностью происходящего?"
    ]
  };


